import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SelectMenu from "./SelectMenu";

const menu = [
  ["None", "All"],
  ["None", "All", "Added", "Owned", "Added and Owned"],
  ["None", "All", "Added", "Owned", "Added and Owned"],
  ["None", "All", "Added", "Owned", "Added and Owned"],
  ["None", "All"],
];

// Instead of storing React elements, store menu indices
function createData(Module, addMenuIdx, viewMenuIdx, updateMenuIdx, deleteMenuIdx) {
  return {
    Module,
    addMenuIdx,
    viewMenuIdx,
    updateMenuIdx,
    deleteMenuIdx,
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell component="th" scope="row">
          {row.Module}
        </TableCell>
        <TableCell align="right">
          <SelectMenu menu={menu[row.addMenuIdx]} />
        </TableCell>
        <TableCell align="right">
          <SelectMenu menu={menu[row.viewMenuIdx]} />
        </TableCell>
        <TableCell align="right">
          <SelectMenu menu={menu[row.updateMenuIdx]} />
        </TableCell>
        <TableCell align="right">
          <SelectMenu menu={menu[row.deleteMenuIdx]} />
        </TableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="permissions-details">
                <TableHead>
                  <TableRow>
                    <TableCell>Add Assets Type</TableCell>
                    <TableCell>Edit Assets Type</TableCell>
                    <TableCell align="right">View Assets Type</TableCell>
                    <TableCell align="right">Delete Assets Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <SelectMenu menu={menu[0]} />
                    </TableCell>
                    <TableCell>
                      <SelectMenu menu={menu[0]} />
                    </TableCell>
                    <TableCell align="right">
                      <SelectMenu menu={menu[0]} />
                    </TableCell>
                    <TableCell align="right">
                      <SelectMenu menu={menu[0]} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    Module: PropTypes.string.isRequired,
    addMenuIdx: PropTypes.number.isRequired,
    viewMenuIdx: PropTypes.number.isRequired,
    updateMenuIdx: PropTypes.number.isRequired,
    deleteMenuIdx: PropTypes.number.isRequired,
  }).isRequired,
};

const rows = [
  createData("Assets", 0, 1, 2, 3),
  createData("HR", 0, 1, 2, 3),
  createData("Finance", 0, 1, 2, 3),
];

export default function PermissionTable() {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell>Module</TableCell>
            <TableCell align="right">Add</TableCell>
            <TableCell align="right">View</TableCell>
            <TableCell align="right">Update</TableCell>
            <TableCell align="right">Delete</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <Row key={index} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}